<script>
  import { feature } from 'topojson-client';
  import topojson from '../../data/world-2.topo.json';

  import Tooltip from './Tooltip.svelte';
  import BaseMap from './BaseMap.svelte';

  export let width;
  export let height;

  const geojson = feature(topojson, Object.keys(topojson.objects)[0]);

  geojson.features = geojson.features.map(feat => ({
    ...feat,
    properties: {
      ...feat.properties,
      id: feat.properties.id.toLowerCase()
    }
  }));

  let tooltipIsoCode = null;
  let tooltipPosition = {
    x: 0,
    y: 0
  };
</script>

<svg {width} {height}>
  {#if width > 0}
    <BaseMap
      {geojson}
      {width}
      {height}
      bind:tooltipIsoCode
      bind:tooltipPosition />
  {/if}
</svg>
{#if tooltipIsoCode}
  <Tooltip isoCode={tooltipIsoCode} position={tooltipPosition} />
{/if}
